import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../store/store';
import BkInformationChip from '../../../../../components/chip/BkInformationChip';
import { BkErrorChip } from '../../../../../components/chip/BkErrorChip';
import PeopleIcon from '@mui/icons-material/People';

const RecipientsTotalNumber = () => {
  const caseParties = useSelector(
    (state: RootState) => state.upload.formData.caseParties,
  );

  const creditors = useSelector(
    (state: RootState) => state.upload.formData.creditors,
  );

  const userUploadedAddresses = useSelector(
    (state: RootState) => state.upload.formData.userUploadedAddresses,
  );

  const caseSource = useSelector(
    (state: RootState) => state.upload.formData.caseSource,
  );

  const errors = useSelector((state: RootState) => state.upload.errors);

  const combinedData = () => {
    const data = [];

    if (caseSource.userSupplied) {
      data.push(...userUploadedAddresses);
    }
    if (caseSource.masterMailingMatrix) {
      data.push(...creditors);
    }
    if (caseSource.importCaseParties) {
      data.push(...caseParties);
    }

    return data;
  };

  const filteredData = combinedData().filter(
    (item) => item.isCertified || item.isFirstClass || item.isOvernight,
  );

  const totalNumber = filteredData.length;

  const totalMails = filteredData.reduce(
    (sum, item) =>
      sum +
      (item.isCertified ? 1 : 0) +
      (item.isFirstClass ? 1 : 0) +
      (item.isOvernight ? 1 : 0),
    0,
  );

  return (
    <div>
      {errors.address !== '' && errors.address !== undefined ? (
        <BkErrorChip label='Please choose at least one recipient' />
      ) : (
        <div style={{ display: 'flex', gap: '0.625rem' }}>
          <BkInformationChip
            label={`${totalNumber} mailable recipient${totalNumber === 1 ? '' : 's'}`}
            icon={<PeopleIcon />}
          />
        </div>
      )}
    </div>
  );
};

export default RecipientsTotalNumber;
